import React from 'react';

function Download() {
  return (
    <>
      <section className="download-section">
        <div className="container">
          <div className="map-container">
            <h2>Find Us Here</h2>
            <p>
              Visit our location or contact us for more information about our MyDearCab services.
            </p>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.1593145063002!2d73.89207087465108!3d18.476441470521763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2eb8e9f34dff5%3A0x3411add1118ac686!2sMYDEARCAB!5e0!3m2!1sen!2sin!4v1761466199284!5m2!1sen!2sin" 
                width="100%" 
                height="400" 
                style={{ border: '0', borderRadius: '8px', maxWidth: '800px' }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="MYDEARCAB Location"
              />
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
}

export default Download;
